module.exports = __webpack_public_path__ + "img/ring_g_c_null_0@3x.aeb48f88.png";